import { ProductTypeSelect } from '@frontend/product/select';
import { ProductType } from '@frontend/product/types';
import { updateField } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import useProductTypeConstraintDataInput from './product-type-constraint-data-input.controller';

const ID = 'product-type-constraint-data-input';
export interface ProductTypeConstraintDataInputProps {
    dispatch: ThunkDispatch<any, any, Action>;
    formId: string;
    id?: string;
    label?: string;
    className?: string;
    required?: boolean;
}

const ProductTypeConstraintDataInput = (props: ProductTypeConstraintDataInputProps) => {
    const viewProps = useProductTypeConstraintDataInput(props);

    return (
        <div
            id={ID}
            className='flex w-full flex-row'>
            <ProductTypeSelect
                required
                value={viewProps.formValues?.type ?? null}
                onSelect={(v) => {
                    props.dispatch(updateField({ formId: props.formId, key: 'data', value: v ? { type: v.value as ProductType } : undefined }));
                }}
            />
        </div>
    );
};

export default ProductTypeConstraintDataInput;
